import React, { Component } from "react";
import Prof from "../Images/Prof.jpg";
import Communication from "../Images/communication_disorders.jpg";
import HomeSchool from "../Images/Home_school.jpg";
import Screening from "../Images/screening.jpg";
import Speech from "../Images/speech_mechanism.jpg";
import Teaching from "../Images/teaching_speech.jpg";
import Family from "../Images/dysfunctional_family.jpg";
import Language from "../Images/language_speech.jpg";
import Exceptionalities from "../Images/exceptionalities.jpg";



class Profile extends Component {
  state = {};
  render() {
    return (
      <div className="container text-justify">
        <div className="text-center">
          <img className="img-fluid" src={Prof} alt="Prof Gadagbui" />
        </div>
        <h1 className="text-center page-header head">
          Professor Grace Yawo Gadagbui
        </h1>
        <p>
          Professor Grace Yawo Gadagbui is a Full Professor in Communication
          Disorders and Sciences since 2004 and had her Inaugural Speech on 25th
          September ,2007 in the University of Education, Winneba, Ghana. She is
          a full fledged Speech and Language Therapist since 1985 from the
          University of Carbondale, Illinois, USA but has been practising Speech
          and Language Teaching since 1975 as a Specialist Trained Teacher for
          the Deaf, Mampong - Akwapim, in the Eastern Region of Ghana. Professor
          Grace Yawo Gadagbui owns the centre “New-Age Academy of Education and
          Research (NAER)” to continue the practice of Speech and Language
          Teaching to those with difficulties in Communication and those with
          Reading Difficulties and Counsel Families with Learners of Special
          needs. She is also into “GUIDE” students and Researchers to write
          Thesis/Dissertations with less difficulty.
        </p>
        <p>
          Professor Grace Yawo Gadagbui has wide experience in Language and
          Speech Therapy. She lectured full-time for two decades and seven years
          in the Department of Special Education Winneba (1993-2020). She had
          been supportive in lecturing students in Language and Speech Therapy
          in UHAS, Ho now with Eye, Ear, Nose and Throat Department, KNUST,
          Kumasi. She continues to supervise Long Essays, Dissertations, Theses
          and including Peer Review of Papers at the centre: New-Age Academy of
          Education and Research (NAER), Winneba.
        </p>

        <div className="head">
          <h4>
            <u>My Philosophy</u>
          </h4>
          <p className="lead text-justify">
            My philosophy is to make Research Candidates feel at ‘EASE’ with
            their research and project reports by training them with the
            technical skills and knowledge that can be practised and transferred
            into writing for acceptance and presentation as in Viva Voce,
            Seminars and Workshops and for publication in Journals.
          </p>
          <p className="lead text-jusify">
            Children and families having children with Communication Disorders
            and Dyslexia (Reading Difficulties) and its associated
            mal-behaviours socially and emotionally will be given remedial
            solutions customized to their needs.
          </p>
        </div>
        <h2 className="published-books">Books Published</h2>
        <ul>
          <li>Education in Ghana and Special Needs of Children</li>
          <li>A Handbook of Language and Speech Deviations.</li>
          <li>Screening for Hearing and Speech Impairment in Children.</li>
          <li>
            Dysfunctional Family: Implications for Educational Interventions.
          </li>
          <li>Anatomy and Physiology of the Speech Mechanism.</li>
          <li>
            Communication Disorders and Performance in Learning Environments.
          </li>
          <li>
            Home-School Partnership and Counselling for Families including
            Families who have Children with Special Needs.
          </li>
          <li>Winning with Distinction.</li>
          <li>
            Exceptionalities, inclusive Education, Personality Disorders and
            Gerontology.
          </li>
          <li>The Teaching of Speech and Language.</li>
        </ul>
        <h2>Samples of Books Published</h2>
        <div className="row">
          <div className="col-md-4">
            <hr />
            <img className="img-fluid" src={Communication} alt="Founders" />
            <figcaption className="text-center in">
              Communication Disorders and Performance in Learning Environments.
            </figcaption>
          </div>
          <div className="col-md-4">
            <hr />
            <img className="img-fluid" src={HomeSchool} alt="Founders" />
            <figcaption className="text-center in">
              Home-School Partnership and Counselling for Families
            </figcaption>
          </div>
          <div className="col-md-4">
            <hr />
            <img className="img-fluid" src={Screening} alt="Founders" />
            <figcaption className="text-center in">
              Screening for Hearing and Speech Impairment in Children.
            </figcaption>
          </div>
          <div className="col-md-4">
            <hr />
            <img className="img-fluid" src={Speech} alt="Founders" />
            <figcaption className="text-center in">
              Anatomy and Physiology of the Speech Mechanism.
            </figcaption>
          </div>
          <div className="col-md-4">
            <hr />
            <img className="img-fluid" src={Teaching} alt="Founders" />
            <figcaption className="text-center in">
              Anatomy and Physiology of the Speech Mechanism.
            </figcaption>
          </div>
          <div className="col-md-4">
            <hr />
            <img className="img-fluid" src={Language} alt="Founders" />
            <figcaption className="text-center in">
              Dysfunctional Family: Implications for Educational Interventions.{" "}
            </figcaption>
          </div>
          <div className="col-md-4">
            <hr />
            <img className="img-fluid" src={Exceptionalities} alt="Founders" />
            <figcaption className="text-center in">
              Dysfunctional Family: Implications for Educational Interventions.{" "}
            </figcaption>
          </div>
          <div className="col-md-4">
            <hr />
            <img className="img-fluid" src={Family} alt="Founders" />
            <figcaption className="text-center in">
              Dysfunctional Family: Implications for Educational Interventions.{" "}
            </figcaption>
          </div>
        </div>
      </div>
    );
  }
}

export default Profile;
